import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

/**
 * Missed Deuce fragment for Indoor Football.
 * Indicates the kickoff did not go through the uprights.
 * Receiving team takes possession.
 */
export default class DeuceMissed extends Fragment {
    constructor() {
        super();
        this.code = "DCEM";
    }

    summarize() {
        return new FragmentSummary(" missed");
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
        summaryContext.homeTeamHasPossession =
            !summaryContext.homeTeamHasPossession;
    }

    getFragmentTeamId() {
        return this.kickedBy?.teamId;
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
